export default __webpack_public_path__ + "static/media/advcoruja-apresentacao.47de3def.png";